// NOTE: this is much faster the lodash.isEmpty, as lodash.isEmpty does Object.keys() then iterates on it,
// this creates performance issues for large objects and avoids array creation everytime
export const isEmptyObject = (obj: object | null | undefined) => {
  if (obj === null || obj === undefined) return true;
  for (const key in obj) {
    if (Object.prototype.hasOwnProperty.call(obj, key)) return false;
  }
  return true;
};
